import * as React from "react";
import Snackbar from "@mui/material/Snackbar";

type SnackbarProps = {
  open: boolean;
  message: string;
  setOpen: Function;
};

const CustomSnackbar = (props: SnackbarProps) => {
  const { open, message, setOpen } = props;

  const handleClose = (event: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  return (
    <Snackbar
      open={open}
      message={message}
      autoHideDuration={3000}
      onClose={handleClose}
    />
  );
};

export default CustomSnackbar;
